import React, { Fragment } from "react";

import { TableExpandableCard } from "../../../../../../components/table/components/TableExpandableCard";
import { DeviceWithType } from "../../../../../../components/devices/DeviceWithType";
import { DiscoveredDevicesDropdownActions } from "../discoveredDevicesDropdownActions";

export const TableCard = ({ type, identifier, manufacturer, lastSeen }) => {
  return (
    <TableExpandableCard
      showExpand={false}
      content={
        <Fragment>
          <DeviceWithType type={type} identifier={identifier} />
          {manufacturer && <div>{manufacturer}</div>}
          {lastSeen && <div className="color-table__cell">{lastSeen}</div>}
        </Fragment>
      }
      aside={
        <DiscoveredDevicesDropdownActions
          device={{ type, manufacturer, identifiers: [identifier] }}
        />
      }
    />
  );
};
